/**
 * This file contains the application's colors.
 *
 * Define color here instead of duplicating them throughout the components.
 * That allows to change them more easily later on.
 */

export const BLACK = "var(--text-color)";
export const WHITE = "var(--bg-color)";
export const PINK = "var(--primary-color)";
export const GREY = "var(--text-color)";
export const WHITE_ALPHA13 = "rgba(255, 255, 255, 0.13)";
export const WHITE_ALPHA77 = "rgba(255, 255, 255, 0.92)"; // text on dark; raised from 0.77 for legibility
export const ANTIQUE_WHITE = "var(--bg-color)";
export const WAX_FLOWER_WHITE = "var(--bg-color)";
export const BATTLESHIP_GREY = "var(--text-color)";
export const DARK = "var(--text-color)";
export const JASPER_RED = "#dc3545";
export const AZURE_BLUE = "#1890ff";
export const BOULDER_GREY = "var(--text-color)";
export const LIGHT_PINK = "var(--primary-color)";
export const DARK_PINK = "var(--primary-color)";
export const TRANSPARENT = "rgba(0, 0, 0, 0)";
export const CLOUDY_GREY = "#6a6a6a";
export const SILVER_CHALICE = "#ababab";
export const VAMPIRE_GREY = "#535352";
export const CLOUD = "#c9c5b8";
export const SATIN_LINEN = "#e8e4dA";
export const WARM_GREY = "#959082";
export const RIVER_BED = "#434B50";
export const HAZEL = "#977721";
export const TUMERIC = "#dab745";
export const YELLOWY_BROWN = "#b38c08";
export const BROWN_BEAR = "#7B5531";
export const CLAY_BROWN = "#B47640";
export const MILK_CHOCOLATE = "#7B4F27";
export const RED_ERROR = "#FF9494";
export const BORDER_WHITE = "var(--bg-color)";
export const POP_UP_BLUR_DESKTOP = "rgba(64, 64, 64, 0.65)";
export const POP_UP_BLUR_MOBILE = "rgba(64, 64, 64, 0.12);";
export const ORANGE = "#FF7A00";
export const OUTERSPACE = "var(--text-color)";
export const OCEAN_BLUE = '#023E9D';
export const SKY_BLUE = '#68BBE5';
export const B_BLUE = '#1575C1';

// ── Card gradient colours (matching webapp) ──────────────────────────────────
export const OceanBlue = '#023E9D';
export const SkyBlue = '#68BBE5';
export const Bblue = '#1575C1';
export const BrownBear = '#7B5531';
export const ClayBrown = '#B47640';
export const MilkChocolate = '#7B4F27';
export const Hazel = '#977721';
export const Turmeric = '#dab745';
export const YellowyBrown = '#b38c08';
export const CloudyGrey = '#6a6a6a';
export const SilverChalice = '#ababab';
export const VampireGrey = '#535352';

// ── Membership Card Gradients ─────────────────────────────────────────────────
export const redesignMembershipPlatinum = 'linear-gradient(135deg, #F9F9F9 0%, #D4D4D4 40%, #FAFAFA 60%, #BDBDBD 100%)';   // Platinum #F9F9F9 -> #D4D4D4 -> #FAFAFA -> #BDBDBD
export const redesignMembershipGold = 'linear-gradient(135deg, #e7c65e 0%, #b28a2c 100%)';       // Gold #e7c65e -> #b28a2c
export const redesignMembershipBronze = 'linear-gradient(135deg, #c98d54 0%, #8a5a2b 100%)';     // Bronze #c98d54 -> #8a5a2b
export const redesignMembershipClassPass = 'linear-gradient(135deg, #9c9c9c 0%, #6f6f6f 100%)'; // Class Pass gray #9c9c9c -> #6f6f6f

// ── Accent / Gradients ────────────────────────────────────────────────────────
export const redesignPrimaryCta = 'linear-gradient(135deg, #ff7eb3 0%, #ec5f96 100%)'; // Primary CTA, live badges, play buttons, logo mark
export const redesignSolidPink = '#ec5f96';                      // Solid pink (fills)
export const redesignSolidPinkBorderText = '#d63f7f';            // Solid pink (text / borders)
export const redesignHeroWash = 'linear-gradient(140deg, #fbe0ec 0%, #f6d2e6 100%)'; // Section band / hero wash

/* ── Mindscript redesign palette ─────────────────────────── */
export const CREAM_BG = "var(--bg-color)";
export const CARD_SURFACE = "var(--bg-color)";

/* Elevated card surfaces — subtly distinct from the section background,
   used for cards (problem cards, testimonial cards) in each theme. */
export const CardSurfaceLight = "#F4F5F6";
export const CardSurfaceDark = "#2B3035";

/* ── Dynamic Theme Pairs ─────────────────────────── */
export const BlackToWhite = "var(--color-black-to-white)";
export const PrimaryMainToBlack = "var(--color-primaryMain-to-black)";
export const PrimaryMainToWhite = "var(--color-primaryMain-to-white)";
export const PrimaryLightToBlack = "var(--color-primaryLight-to-black)";
export const PrimaryLightToWhite = "var(--color-primaryLight-to-white)";
export const PrimaryDarkToBlack = "var(--color-primaryDark-to-black)";
export const PrimaryDarkToWhite = "var(--color-primaryDark-to-white)";
export const GreyToWhiteAlpha = "var(--color-grey-to-whiteAlpha77)";
export const DarkToBlack = "var(--color-dark-to-black)";

//new colors 
// ==============================|| THEME - COLORS ||============================== //

export const White = '#ffffff';
export const Black = '#000000';
export const Dark = '#212529';

// Primary Colors
export const PrimaryMain = '#FF7BA9';
export const PrimaryLight = '#FFB3CB';
export const PrimaryDark = '#E85A8A';
export const PinkAccent = '#D63F7F'; // deep pink for filled CTAs (matches the web app's redesign accent)
export const PinkWash = '#FDE9EF'; // soft pink band behind CTAs


// Secondary Colors
export const SecondaryMain = '#6C757D';
export const SecondaryLight = '#ADB5BD';
export const SecondaryDark = '#495057';

// Success, Warning, Error
export const SuccessMain = '#28a745';
export const SuccessLight = '#81c784';
export const SuccessDark = '#1b5e20';

export const WarningMain = '#ff9800';
export const WarningLight = '#ffb74d';
export const WarningDark = '#f57c00';

export const ErrorMain = '#dc3545';
export const ErrorLight = '#ef5350';
export const ErrorDark = '#c62828';

// Info
export const InfoMain = '#1890ff';
export const InfoLight = '#64b5f6';
export const InfoDark = '#1565c0';

// Grey shades
export const Grey50 = '#fafafa';
export const Grey100 = '#f5f5f5';
export const Grey200 = '#eeeeee';
export const Grey300 = '#e0e0e0';
export const Grey400 = '#bdbdbd';
export const Grey500 = '#9e9e9e';
export const Grey600 = '#757575';
export const Grey700 = '#616161';
export const Grey800 = '#424242';
export const Grey900 = '#212121';

// Paper and Background
export const Paper = '#ffffff';
export const BackgroundDefault = '#f4f6f8';
export const BackgroundDark = '#1a223f';

// Transparent
export const Transparent = 'rgba(0, 0, 0, 0)';
export const Transparent10 = 'rgba(0, 0, 0, 0.1)';
export const Transparent20 = 'rgba(0, 0, 0, 0.2)';
export const Transparent50 = 'rgba(0, 0, 0, 0.5)';

//Rest methods
export const GetRequest = '#28a745';
export const PostRequest = '#007bff';
export const PutRequest = '#ffc107';
export const DeleteRequest = '#dc3545';
export const DefaultRequest = '#6c757d';


